const defaultState = {
  loading: true,
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {
    case "FETCH_SHOOTING_DAY_LOCATIONS_PENDING": {
      return {
        ...state,
        loading: true,
        errors: null,
      };
    }

    case "FETCH_SHOOTING_DAY_LOCATIONS_FULFILLED": {
      return {
        ...state,
        locations: action.payload.data,
        loading: false,
        errors: null,
      };
    }

    case "FETCH_SHOOTING_DAY_LOCATIONS_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: action.payload.response.data.errors,
      };
    }

    default:
      return state;
  }
};

export default reducer;
